

<template>
    <el-dialog title="添加平台" append-to-body :visible.sync="platformDialog" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top">
            <el-form-item label="平台名称" prop="platform_name">
                <el-input size="small" v-model="formData.platform_name" placeholder="请输入平台名称"></el-input>
            </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { platformEdit } from "@/api/index.js"
export default {
    name:'platform_edit',
    props: {
        platformDialog: {
            type: Boolean,
            default: false
        },
        platformId: {
            type: Number,
            default: 0
        },
        platformName: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            BtnDisabled:false,
            formData: {
                platform_name: "",
            },
            formRules: {
                platform_name: [
                    {required: true, message: "请输入平台名称"}
                ]
            },
        }
    },
    created() {
        if(this.platformName){
            this.formData.platform_name = this.platformName
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:platformDialog", false)
        },
        handleDialogConfirm() {

            this.$refs.formData.validate(valid => {
                if (valid) {
                    if(this.formData.platform_name == this.platformName){
                        this.handleDialogClose()
                        return false
                    }
                    this.BtnDisabled = true
                    let postData = {
                        platform_name: this.formData.platform_name
                    }
                    if(this.platformId){
                        postData.id = this.platformId
                    }
                    platformEdit(postData).then(res=> {
                        if(res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: this.platformId ? '编辑成功' : '添加成功',
                                duration: 1500,
                                onClose: () => {
                                    this.handleDialogClose()
                                    this.$emit('success')
                                    this.BtnDisabled = false
                                }
                            })
                        }else{
                            this.BtnDisabled = false
                        }
                    })

                }
            })
        },

    }
}
</script>
